import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

import MosruIndicationButton from './MosruIndicationButton';
import MosruGetInfoButton from './MosruGetInfoButton';
import MosruEditButton from './MosruEditButton';
import EmailSendButton from './EmailSendButton';
import IntegrationEditForm from './IntegrationEditForm';
import { isEditableIntegration } from '../constants/constants';
import { GisZhkkhIntegrationActions, isGisZhkkh } from '../gisZhkkh';
import dayjs from 'dayjs';

const getValueByPath = (obj, path) => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};

const IntegrationItem = ({ title, icon, customIcon, fields, integration, deleteHandle, deviceId, objectId, isSensor }) => {
  const { device_integration_id: id, key, integration_name } = integration ?? {};
  const [showEditModal, setEditModal] = React.useState(false);

  const buttons = [
    {
      name: 'Редактировать интеграцию',
      handleClick: () => setEditModal(true),
      hideButton: !isEditableIntegration.includes(key),
      icon: <EditIcon className={'text-gray-600 hover:text-gray-700 transition-colors'} />,
    },
    {
      name: 'Удалить интеграцию',
      hideButton: false,
      handleClick: () => deleteHandle(id, key, deviceId, integration_name),
      icon: <DeleteForeverOutlinedIcon className={'text-red-500 hover:text-red-600 transition-colors'} />,
    },
  ];

  return (
    <div className="flex flex-row gap-x-2 mt-1">
      {customIcon ? <img alt={title} src={icon} className={'rounded object-contain w-7 h-7'} /> : icon}
      <div className={'flex flex-col w-full'}>
        <div className={'flex justify-between items-center'}>
          <p className="text-gray-700 text-sm">{title}</p>

          <div className="flex items-center gap-x-2">
            {buttons.map(({ handleClick, name, icon, hideButton }) => {
              return hideButton ? null : (
                <button onClick={handleClick} key={name}>
                  {icon}
                </button>
              );
            })}
          </div>
        </div>
        <div className="flex flex-row flex-wrap justify-between items-end pb-1 gap-x-2">
          {Object.entries(fields).map(([fieldKey, label]) => {
            let value = getValueByPath(integration?.config || integration?.cfg || {}, fieldKey);
            if (!value) return null;
            // с бэкенда вместо даты отправки приходит дата создания :
            if (fieldKey === 'date') {
              value = dayjs(value).date() || 1;
            }
            return (
              <div key={fieldKey} className="flex flex-col mr-2">
                <p className="text-xs text-gray-500">{label}:</p>
                <p className="text-sm text-gray-800">{value}</p>
              </div>
            );
          })}
        </div>
        {integration?.metadata?.message && (
          <div>
            <p className={'text-xs text-gray-500'}>⚠️ Сообщение:</p>
            <p>{integration?.metadata?.message}</p>
          </div>
        )}
        {isGisZhkkh(key) && <GisZhkkhIntegrationActions integration={integration} deviceId={deviceId} />}
        {key === 'mosru' && (
          <div className="flex flex-row justify-between items-center gap-x-2">
            <p className={'text-xs text-gray-500'}>Действия Mos.ru:</p>
            <div className="flex gap-1">
              <MosruGetInfoButton objectId={objectId} />
              <MosruIndicationButton deviceId={deviceId} />
              <MosruEditButton
                integration_id={integration?.device_integration_id}
                pay_code={integration?.config?.pay_code}
                send_at_day={integration?.config?.send_at_day}
              />
            </div>
          </div>
        )}
        {key === 'reporter.mail' && <EmailSendButton integration_id={integration?.device_integration_id} />}
      </div>
      <IntegrationEditForm
        showModal={showEditModal}
        setShowModal={setEditModal}
        deviceId={deviceId}
        id={id}
        integrationKey={key}
        defaultValues={integration?.config}
      />
    </div>
  );
};

export default IntegrationItem;
